<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" offset="0" md="10" offset-md="0">
                <h2 class="primary--text">Exportações</h2>
                <v-breadcrumbs
                    large
                    :items="crumbs"
                    divider="/"
                    class="pl-0"
                ></v-breadcrumbs>
            </v-col>

            <v-col cols="12" offset="0" md="4" offset-md="0">
                <v-select
                    v-model="fields.type"
                    :items="items"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                    label="Ficheiro *"
                ></v-select>
            </v-col>

            <v-col cols="12" offset="0" md="6" v-if="fields.type =='faults' || fields.type == 'diary' || fields.type =='manouver_diary' || fields.type =='materiais' || fields.type == 'diary_ccop'">
                <v-autocomplete
                    v-model="fields.work_id"
                    :items="works"
                    :item-text="item => item.Codigo +' - ' + item.Descricao"
                    dense
                    item-value="Id"
                    label="Obra *"
                    outlined
                    @change="obraChanged"
                ></v-autocomplete>
            </v-col>

            <v-col cols="12" offset="0" md="6" v-show="false">
                <v-autocomplete
                    v-model="fields.user_id"
                    :items="normalizedSectionDiaryUsers"
                    :item-text="item => item.funcionario.Codigo + ' - ' + item.name"
                    item-value="id"
                    dense
                    clearable
                    label="Funcionário *"
                    outlined
                ></v-autocomplete>
            </v-col>

            <v-col cols="12" offset="0" md="6" v-if="fields.type == 'diary_especiality_old' || fields.type == 'diary_especiality'">
                <v-autocomplete
                    v-model="fields.work_id"
                    :items="kpi_works"
                    :item-text="item => item.Codigo +' - ' + item.Descricao"
                    dense
                    item-value="Id"
                    label="Obra *"
                    outlined
                    @change="obraChanged"
                ></v-autocomplete>
            </v-col>

            <v-col cols="12" offset="0" md="6" v-if="fields.type == 'rh'">
                <v-autocomplete
                    v-model="fields.work_id"
                    :items="works"
                    :item-text="item => item.Codigo +' - ' + item.Descricao"
                    dense
                    item-value="Id"
                    label="Obra *"
                    outlined
                ></v-autocomplete>
            </v-col>

            <v-col cols="12" offset="0" md="6" v-if="fields.type == 'epis'">
                <v-autocomplete
                    v-model="fields.user_id"
                    :items="normalizedWorkers"
                    :item-text="item => item.Codigo + ' - ' + item.Nome"
                    item-value="Codigo"
                    dense
                    clearable
                    label="Colaborador *"
                    outlined
                ></v-autocomplete>
            </v-col>

            <v-col cols="12" offset="0" md="6" v-if="naturezas.length > 0">
                <v-autocomplete
                    v-model="fields.natureza_id"
                    :items="naturezas"
                    :item-text="item => item.code +' - ' + item.natureza"
                    dense
                    item-value="id"
                    clearable
                    label="Naturezas"
                    outlined
                ></v-autocomplete>
            </v-col>

            <v-col cols="12" offset="0" md="5" v-if="frentes.length > 0" offset-md="0">
                <v-autocomplete
                    v-model="fields.frente_id"
                    :items="frentes"
                    :item-text="item => item.SubEmp +' - ' + item.Descricao"
                    dense
                    item-value="ID"
                    label="Frente"
                    outlined
                    clearable
                    @change="changeFrente"
                ></v-autocomplete>
            </v-col>

            <v-col cols="12" offset="0" md="5" v-if="classes.length > 0" offset-md="0">
                <v-autocomplete
                    v-model="fields.classe_id"
                    :items="classes"
                    :item-text="item => item.Descricao"
                    dense
                    item-value="ID"
                    clearable
                    label="Classe"
                    outlined
                ></v-autocomplete>
            </v-col>

            <v-col cols="12" offset="0" md="6" v-if="fields.type == 'rh'">
                <v-autocomplete
                    v-model="fields.categorias"
                    :items="categoriasWithSelectAll"
                    :item-text="item => item.Desig"
                    dense
                    item-value="ObjetoId"
                    label="Categorias *"
                    outlined
                    multiple
                    chips
                    deletable-chips
                    :search-input.sync="categoriaSearch"
                    :no-data-text="categorias_list.length === 0 ? 'A carregar categorias...' : 'Nenhuma categoria encontrada'"
                    @change="handleCategoriaChange"
                    @blur="clearCategoriaSearch"
                >
                    <template v-slot:prepend-item>
                        <v-list-item>
                            <v-list-item-content>
                                <v-text-field
                                    v-model="categoriaSearch"
                                    placeholder="Pesquisar categorias..."
                                    prepend-inner-icon="mdi-magnify"
                                    dense
                                    outlined
                                    hide-details
                                    class="ma-2"
                                    @click.stop
                                    @keydown.stop
                                ></v-text-field>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item
                            ripple
                            @mousedown.prevent
                            @click="toggleSelectAllCategorias"
                        >
                            <v-list-item-action>
                                <v-icon :color="fields.categorias.length > 0 ? 'indigo darken-4' : ''">
                                    {{ iconSelectAllCategorias }}
                                </v-icon>
                            </v-list-item-action>

                            <v-list-item-content>
                                <v-list-item-title>Selecionar Todos</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-divider class="mt-2"></v-divider>
                    </template>
                </v-autocomplete>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="3" v-if="fields.type == 'supplier_evaluation'">
                <v-select
                    v-model="fields.year"
                    :items="supplierEvaluationYears"
                    label="Ano *"
                    outlined
                    dense
                ></v-select>
            </v-col>

            <v-col cols="12" md="2" v-if="requiresDateRange && fields.type !== 'rh'" offset-md="0">
                <DateInput 
                    label="Data Inicial *"
                    :outlined="true"
                    placeholder="Insira Data Inicial"
                    v-model="fields.init"
                    rules="required"
                />

                <p
                    v-if="(fields.type == 'diary_especiality_old' || fields.type == 'diary_especiality') && suggestedDates.start != null"
                    class="text-caption mt-0 ml-2"
                    style="color: #999;"
                >
                    Sugestão KPI: {{ suggestedDates.start }}
                </p>
            </v-col>

            <v-col cols="12" md="2" v-if="requiresDateRange && fields.type !== 'rh'">
                <DateInput 
                    label="Data Final *"
                    placeholder="Insira Data Final"
                    :outlined="true"
                    v-model="fields.end"
                    rules="required"
                />

                <p
                    v-if="(fields.type == 'diary_especiality_old' || fields.type == 'diary_especiality') && suggestedDates.end != null"
                    class="text-caption mt-0 ml-2"
                    style="color: #999;"
                >
                    Sugestão KPI: {{ suggestedDates.end }}
                </p>
            </v-col>
            
            <v-col cols="12" md="3" v-if="fields.type == 'rh'">
                <v-select
                    v-model="fields.month"
                    :items="monthOptions"
                    item-text="text"
                    item-value="value"
                    label="Mês *"
                    outlined
                    dense
                ></v-select>
            </v-col>

            <v-col cols="12" md="3" v-if="fields.type == 'rh'">
                <v-select
                    v-model="fields.year"
                    :items="yearOptions"
                    label="Ano *"
                    outlined
                    dense
                ></v-select>
            </v-col>

            <v-col cols="12" offset="0" md="10" offset-md="1" align="center">
                <v-btn
                    class="success" 
                    rounded 
                    @click="exportFile"
                    :disabled="!canExport"
                >
                    Exportar
                </v-btn>
            </v-col>
        </v-row>

        <ErrorSnackbar v-model="error.show" :message="error.message"/>
        <Loader v-if="loader"/>

        <v-row>
            <v-col cols="12" offset="0" md="12" offset-md="0">
                <v-btn class="mt-8 mb-4" color="primary" @click="loadExportQueue" :loading="loadingTable">
                    Atualizar Tabela
                </v-btn>

                <v-data-table
                    :headers="headers"
                    :items="exportQueue"
                    :items-per-page="10"
                    class="elevation-4"
                    dense
                    :footer-props="{
                        'items-per-page-options': [5, 10, 15, 20, 50],
                        'items-per-page-text': 'Resultados por página'
                    }"
                >
                    <template v-slot:item.id="{ item }">
                        {{ item.id.slice(0, 6) }}
                    </template>

                    <template v-slot:item.type="{ item }">
                        {{ getTypeLabel(item.type) }}
                    </template>

                    <template v-slot:item.status="{ item }">
                        <v-chip v-if="item.file_path != 0" :color="getColor(item.status)" small>
                            {{ item.status }}
                        </v-chip>
                        <v-chip v-else :color="'gray'" small>
                            Ficheiro sem dados
                        </v-chip>
                    </template>

                    <template v-slot:item.created_at="{ item }">
                        {{ formatDate(item.created_at) }}
                    </template>

                    <template v-slot:item.file_path="{ item }">
                        <v-btn
                            v-if="item.status === 'PROCESSED'"
                            v-show="item.file_path != 0"
                            icon
                            @click="downloadFile(item)"
                            small
                        >
                            <v-icon>mdi-download</v-icon>
                        </v-btn>

                        <v-icon v-else small>mdi-timer-sand</v-icon>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-dialog v-model="showDialog" max-width="800px" persistent>
            <v-card>
                <v-card-title class="headline white--text bg-primary">
                    A processar...
                </v-card-title>

                <v-card-text>
                    A sua exportação será processada no nosso servidor. <br>
                    Quando estiver pronta poderá descarregá-la na tabela abaixo.
                </v-card-text>

                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="showDialog = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import DateInput from "@/components/UI/Inputs/DateInput";
import ErrorSnackbar from "@/components/UI/Snackbars/ErrorSnackbar";
import Loader from "@/components/UI/Loaders/Loader";
import Exportation from "@/api/Exportation.js";
import Classe from "@/api/Classe.js";
import FrenteObra from "@/api/FrenteObra.js";
import DiaryKPI from "@/api/DiaryKPI.js";
import EPIS from "@/api/EPIS.js";
import Funcionario from "@/api/Funcionario.js";
import SectionDiaries from "@/api/SectionDiaries.js";

export default {
    name: "Exports",

    components: {
        DateInput,
        ErrorSnackbar,
        Loader
    },

    data() {
        return {
            loader: false,

            error: {
                show: false,
                message: ''
            },

            fields: {
                type: null,
                work_id: null,
                init: null,
                end: null,
                extension: 'Excel',
                classe_id: null,
                frente_id: null,
                natureza_id: null,
                categorias: [],
                month: null,
                year: null,
                user_id: null
            },

            works: [],
            kpi_works: [],
            classes: [],
            workers: [],
            sectionDiaryUsers: [],
            frentes: [],
            naturezas: [],
            categorias_list: [],
            categoriaSearch: '',

            monthOptions: [
                { value: 1, text: 'Janeiro' },
                { value: 2, text: 'Fevereiro' },
                { value: 3, text: 'Março' },
                { value: 4, text: 'Abril' },
                { value: 5, text: 'Maio' },
                { value: 6, text: 'Junho' },
                { value: 7, text: 'Julho' },
                { value: 8, text: 'Agosto' },
                { value: 9, text: 'Setembro' },
                { value: 10, text: 'Outubro' },
                { value: 11, text: 'Novembro' },
                { value: 12, text: 'Dezembro' }
            ],

            yearOptions: [],

            showDialog: false,
            exportQueue: [],
            loadingTable: false,

            headers: [
                { text: 'ID', value: 'id' },
                { text: 'Tipo', value: 'type' },
                { text: 'Status', value: 'status' },
                { text: 'Data', value: 'created_at' },
                { text: 'Download', value: 'file_path' },
            ],

            typeLabels: {
                diary: "Partes Diárias",
                manouver_diary: "Diária de Manobrador",
                diary_especiality: "Relatório de Rendimentos",
                diary_especiality_old: "KPI apenas com diárias",
                faults: "Relatório de Faltas",
                materiais: "Materiais (por Obra)",
                materials: "Materiais (geral)",
                subempreitadas: "Subempreitadas",
                rh: "Exportação - RH",
                epis: "Exportação de EPIS",
                diary_ccop: "Rendimentos CCOP",
                supplier_evaluation: "Avaliações de Fornecedores",
                section_diaries: "Diárias de secção",
                active_works_export: "Obras Ativas"
            },

            suggestedDates: {
                start: null,
                end: null
            },

            users: []
        };
    },

    mounted() {
        if (!this.$store.getters.hasPermission([
            'super',
            'exports.create',
            'export.diaries',
            'diaries.export_manouver_diary',
            'export.perf_report',
            'export.kpi',
            'export.faults',
            'export.section_diaries',
            'export.materials',
            'export.subempreitadas',
            'export.rh',
            'export.epis',
            'supplier_evaluations.export',
            'export.active_works'
        ])) {
            this.$router.push('/forbidden');
        }

        this.fillBaseData();
        this.initializeRHDefaults();

        if (this.items.length == 1) {
            this.fields.type = "diary";
        }
    },

    methods: {
        downloadFile(item) {
            if (item.file_path == 0) {
                return;
            }

            const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
            window.open(item.file_path, isStandalone ? '_self' : '_blank');
        },

        async obraChanged(val) {
            if (this.fields.type != 'diary_especiality' && this.fields.type != 'diary_especiality_old') {
                return;
            }

            if (this.fields.type === 'diary_especiality' || this.fields.type === 'diary_especiality_old') {
                const obra = this.kpi_works.find(item => item.Id === val);

                if (obra) {
                    if (obra.work_kpi_start) {
                        this.fields.init = obra.work_kpi_start;
                        this.suggestedDates.start = obra.work_kpi_start;
                    }

                    if (obra.work_kpi_end) {
                        this.fields.end = obra.work_kpi_end;
                        this.suggestedDates.end = obra.work_kpi_end;
                    }
                }
            }

            if (this.fields.type == 'diary_especiality') {
                await DiaryKPI.getNaturezasDeObra(val).then((resp) => {
                    this.naturezas = resp.data;
                });
            }

            let ObraPai = null;

            this.works.forEach(element => {
                if (element.Id == val) {
                    ObraPai = element.Codigo;
                }
            });

            await FrenteObra.all(ObraPai).then((resp) => {
                this.frentes = resp.data;
            });

            if (this.frentes.length == 0) {
                Classe.getClassesByObraPai(val).then((resp) => {
                    this.classes = resp.data;
                });
            }
        },

        changeFrente(val) {
            let aux = null;

            this.frentes.forEach(element => {
                if (element.ID == val) {
                    aux = element.SubEmp;
                }
            });

            let data = {
                SubEmp: aux
            };

            Classe.getClasses(data).then((resp) => {
                this.classes = resp.data;
            });
        },

        fillBaseData() {
            this.$store.dispatch("listObras")
                .then(res => {
                    let obra = res.data;

                    obra.forEach(element => {
                        if (element.Tipo == 'O') {
                            this.works.push(element);
                        }
                    });
                });

            DiaryKPI.getObras({}).then((resp) => {
                this.kpi_works = resp.data;
            });

            Exportation.getWorksersCategories().then((resp) => {
                this.categorias_list = resp.data;
            }).catch(err => {
                console.error('Erro ao carregar categorias:', err);
            });

            Funcionario.allNoRestrictions().then((resp) => {
                this.workers = resp.data.conduril;
            }).catch(err => {
                console.error('Erro ao carregar colaboradores:', err);
            });

            EPIS.getUserInEpis().then(res => {
                this.users = res.data;
            }).catch(err => {
                console.error('Erro ao carregar utilizadores:', err);
            });

            SectionDiaries.getUsersExport().then(res => {
                this.sectionDiaryUsers = res.data;
            }).catch(err => {
                console.error('Erro ao carregar funcionários para diárias de secção:', err);
            });

            this.loadExportQueue();
        },

        exportFile() {
            this.loader = true;

            let params = { ...this.fields };

            if (params.type === 'rh') {
                const today = new Date().toISOString().split('T')[0];
                params.init = today;
                params.end = today;
            }

            if (params.type === 'section_diaries') {
                params.work_id = null;
            }

            if (params.type === 'active_works_export') {
                params.work_id = null;
                params.classe_id = null;
                params.frente_id = null;
                params.natureza_id = null;
                params.user_id = null;
                params.month = null;
                params.year = null;
                params.categorias = [];
                params.extension = 'PDF';
            }

            this.$store.dispatch('export_file', params)
                .then(() => {
                    this.loader = false;
                    this.showDialog = true;
                })
                .catch(err => {
                    this.loader = false;
                    console.log(err);
                    this.error.message = "Erro ao agendar exportação.";
                    this.error.show = true;
                });
        },

        loadExportQueue() {
            this.loadingTable = true;

            Exportation.getExports()
                .then(res => {
                    this.exportQueue = res.data;
                })
                .catch(() => {
                    this.error.message = "Erro ao carregar exportações.";
                    this.error.show = true;
                })
                .finally(() => this.loadingTable = false);
        },

        getColor(status) {
            switch (status) {
                case 'WAITING':
                    return 'yellow';
                case 'PROCESSING':
                    return 'orange';
                case 'PROCESSED':
                    return 'green';
                case 'FAILED':
                    return 'red';
                default:
                    return 'blue';
            }
        },

        formatDate(dateStr) {
            if (!dateStr) {
                return '-';
            }

            const d = new Date(dateStr);
            return d.toLocaleString('pt-PT');
        },

        getTypeLabel(type) {
            return this.typeLabels[type] || type;
        },

        toggleSelectAllCategorias() {
            this.$nextTick(() => {
                const filteredItems = this.categoriasWithSelectAll;
                const filteredIds = filteredItems.map(item => item.ObjetoId);
                const selectedFiltered = this.fields.categorias.filter(id => filteredIds.includes(id));

                if (selectedFiltered.length === filteredIds.length) {
                    this.fields.categorias = this.fields.categorias.filter(id => !filteredIds.includes(id));
                } else {
                    const newSelection = [...this.fields.categorias];

                    filteredIds.forEach(id => {
                        if (!newSelection.includes(id)) {
                            newSelection.push(id);
                        }
                    });

                    this.fields.categorias = newSelection;
                }
            });
        },

        handleCategoriaChange(value) {
        },

        clearCategoriaSearch() {
            this.categoriaSearch = '';
        },

        initializeRHDefaults() {
            const currentDate = new Date();

            this.fields.month = currentDate.getMonth() + 1;
            this.fields.year = currentDate.getFullYear();

            const currentYear = currentDate.getFullYear();

            this.yearOptions = [];

            for (let year = currentYear - 10; year <= currentYear + 2; year++) {
                this.yearOptions.push(year);
            }
        }
    },

    computed: {
        requiresDateRange() {
            return [
                'diary_ccop',
                'diary_especiality_old',
                'diary',
                'diary_especiality',
                'manouver_diary',
                'faults',
                'materiais',
                'subempreitadas',
                'section_diaries',
                'active_works_export'
            ].includes(this.fields.type);
        },

        supplierEvaluationYears() {
            const currentYear = new Date().getFullYear();
            const years = [];

            for (let y = currentYear; y >= 2024; y--) {
                years.push(y);
            }

            return years;
        },

        normalizedWorkers() {
            return this.workers;
        },

        normalizedSectionDiaryUsers() {
            return this.sectionDiaryUsers.map(user => {
                const id = user.id || user.Id || user.user_id || user.UserId;
                const nome = user.name || user.Name || user.Nome || user.nome || '';
                const email = user.email || user.Email || '';
                const username = user.username || user.Username || '';
                const numero = user.number || user.Number || user.Numero || user.numero || '';

                let label = nome;

                if (email) {
                    label = label ? `${label} - ${email}` : email;
                } else if (username) {
                    label = label ? `${label} - ${username}` : username;
                } else if (numero) {
                    label = label ? `${label} - ${numero}` : numero;
                } else if (!label) {
                    label = String(id);
                }

                return {
                    ...user,
                    id,
                    label
                };
            }).filter(user => user.id !== undefined && user.id !== null);
        },

        normalizedUsers() {
            return this.users.map(user => {
                const id = user.id || user.Id || user.user_id || user.UserId;
                const nome = user.name || user.Name || user.Nome || user.nome || '';
                const email = user.email || user.Email || '';
                const username = user.username || user.Username || '';
                const numero = user.number || user.Number || user.Numero || user.numero || '';

                let label = nome;

                if (email) {
                    label = label ? `${label} - ${email}` : email;
                } else if (username) {
                    label = label ? `${label} - ${username}` : username;
                } else if (numero) {
                    label = label ? `${label} - ${numero}` : numero;
                } else if (!label) {
                    label = String(id);
                }

                return {
                    ...user,
                    id,
                    label
                };
            }).filter(user => user.id !== undefined && user.id !== null);
        },

        items() {
            let returner = [];

            returner.push(
                {
                    id: 'retencoes',
                    name: "retencoes",
                    show: this.$store.getters.hasPermission(['super', 'export.diaries'])
                },
                {
                    id: 'diary',
                    name: "Partes Diárias",
                    show: this.$store.getters.hasPermission(['super', 'export.diaries'])
                },
                {
                    id: 'manouver_diary',
                    name: 'Diárias Manobrador',
                    show: this.$store.getters.hasPermission(['super', 'diaries.export_manouver_diary']),
                },
                {
                    id: 'diary_especiality',
                    name: "Relatório de Rendimentos",
                    show: this.$store.getters.hasPermission(['super', 'export.perf_report'])
                },
                {
                    id: 'diary_especiality_old',
                    name: "KPI apenas com Diárias",
                    show: this.$store.getters.hasPermission(['super', 'export.kpi'])
                },
                {
                    id: 'faults',
                    name: "Relatório de Faltas",
                    show: this.$store.getters.hasPermission(['super', 'export.faults'])
                },
                {
                    id: 'materiais',
                    name: "Materiais",
                    show: this.$store.getters.hasPermission(['super', 'export.materials'])
                },
                {
                    id: 'subempreitadas',
                    name: "Subempreitadas",
                    show: this.$store.getters.hasPermission(['super', 'export.subempreitadas'])
                },
                {
                    id: 'active_works_export',
                    name: "Obras Ativas",
                    show: this.$store.getters.hasPermission(['super', 'export.active_works'])
                },
                {
                    id: 'rh',
                    name: "Exportação - RH",
                    show: this.$store.getters.hasPermission(['super', 'export.rh'])
                },
                {
                    id: 'epis',
                    name: "Exportação de EPIS",
                    show: this.$store.getters.hasPermission(['super', 'export.epis'])
                },
                {
                    id: 'diary_ccop',
                    name: "Rendimentos CCOP",
                    show: this.$store.getters.hasPermission(['super', 'export.perf_report'])
                },
                {
                    id: 'supplier_evaluation',
                    name: "Avaliações de Fornecedores",
                    show: this.$store.getters.hasPermission(['super', 'supplier_evaluations.export'])
                },
                {
                    id: 'section_diaries',
                    name: "Diárias de secção",
                    show: this.$store.getters.hasPermission(['super', 'export.section_diaries'])
                }
            );

            let final_ar = [];

            returner.forEach(element => {
                if (element.show) {
                    final_ar.push(element);
                }
            });

            return final_ar;
        },

        crumbs() {
            return [
                {
                    text: 'Exportações',
                    disabled: true,
                    to: '#',
                    exact: true,
                },
            ];
        },

        canExport() {
            if (this.fields.type === 'supplier_evaluation') {
                return !!this.fields.year;
            }

            if (!this.fields.type) {
                return false;
            }

            if (this.fields.type === 'materiais') {
                return !!this.fields.work_id && !!this.fields.init && !!this.fields.end;
            }

            if (this.fields.type === 'section_diaries') {
                return !!this.fields.init && !!this.fields.end;
            }

            if (this.fields.type === 'subempreitadas') {
                return !!this.fields.init && !!this.fields.end;
            }

            if (this.fields.type === 'active_works_export') {
                return !!this.fields.init && !!this.fields.end;
            }

            if (this.fields.type === 'rh') {
                return !!this.fields.work_id && !!this.fields.month && !!this.fields.year && this.fields.categorias.length > 0;
            }

            if (this.fields.type === 'epis') {
                return !!this.fields.user_id;
            }

            return true;
        },

        categoriasWithSelectAll() {
            if (!this.categoriaSearch) {
                return this.categorias_list;
            }

            return this.categorias_list.filter(item =>
                item.Desig.toLowerCase().includes(this.categoriaSearch.toLowerCase()) ||
                item.Codigo.toLowerCase().includes(this.categoriaSearch.toLowerCase())
            );
        },

        allCategoriasSelected() {
            const filteredItems = this.categoriasWithSelectAll;
            const filteredIds = filteredItems.map(item => item.ObjetoId);
            const selectedFiltered = this.fields.categorias.filter(id => filteredIds.includes(id));

            return filteredItems.length > 0 && selectedFiltered.length === filteredIds.length;
        },

        someCategoriasSelected() {
            const filteredItems = this.categoriasWithSelectAll;
            const filteredIds = filteredItems.map(item => item.ObjetoId);
            const selectedFiltered = this.fields.categorias.filter(id => filteredIds.includes(id));

            return selectedFiltered.length > 0 && !this.allCategoriasSelected;
        },

        iconSelectAllCategorias() {
            if (this.allCategoriasSelected) {
                return 'mdi-close-box';
            }

            if (this.someCategoriasSelected) {
                return 'mdi-minus-box';
            }

            return 'mdi-checkbox-blank-outline';
        }
    }
};
</script>

<style scoped>
</style>